import React, { useState, useEffect } from 'react';
//Components 
import { Row, Col, Container, Button } from 'react-bootstrap';
import { RenderIf } from '../utils/RenderIf';
import { MachinesFetchAPI } from '../../api/Machines';
import { Modal } from 'react-bootstrap';
//PDF
import { PDFViewer, PDFDownloadLink } from '@react-pdf/renderer';
import DocPdf from '../Pdf/DocPdf';
import InvoicePDF from '../Pdf/documents/InvoicePDF';
//API 
import { DiscountFetchAPI } from '../../api/Discounts';
import { OrdersFetchAPI } from '../../api/Orders';
import { PrinterFetchAPI } from '../../api/Printer';
import { BranchOfficeFetchAPI } from '../../api/BranchOffices';
import { CategriesPosFetchAPI } from '../../api/Paymentpost/CategoriesPos';
import { PaymentMethodFetchAPI } from '../../api/Paymentpost/PaymentMethod';
import LoadingAlert from '../Alerts/LoadingAlert';
import { PaymentOperations } from '../../utils/PaymentOperations';
//Alerts 
import ErrorAlert from '../Alerts/ErrorAlert';
import SuccessAlert from '../Alerts/SuccessAlert';
import printOrderData from '../PaymentPost/PrintOrderData';
//Utils
import { buildCloudinaryImageUrl } from '../../utils/CloudinaryImageUrl';
import { formatVoucherString, resolveOrderVoucher } from '../../utils/FormatVoucherString';
//IMG
import defaultImage from "../../assets/img/default.png";

const OrderDetails = ({ pos, orderData, order_type, business_data, setLoad, setModalShow, temporalOrders, setTemporalOrdersData }) => {
    //Variables
    const token = localStorage.getItem('x-access-token');
    const machineToken = localStorage.getItem('x-access-machine-token');
    let logo = localStorage.getItem('businessLogo') !== undefined && localStorage.getItem('businessLogo') !== null && localStorage.getItem('businessLogo') !== 'null' && localStorage.getItem('businessLogo') !== 'undefined' ? localStorage.getItem('businessLogo') : '';

    //States
    const [orderDetailDiscountTotal, setOrderDetailDiscountTotal] = useState(0);
    const [orderDetailGroups, setOrderDetailGroups] = useState([]);
    const [selectDiscount, setSelectDiscount] = useState({})
    const [businessDiscounts, setBusinessDiscounts] = useState([]);
    const [modalShowVoucher, setmodalShowVoucher] = useState(false)
    const [modalCoupon, setModalCoupon] = useState(false)
    const [infoMachine, setInfoMachine] = useState({ machine_name: "" })
    const [eventHandler, setEventHandler] = useState(0);
    const [infoPrinter, setInfoPrinter] = useState({ printer_comanda: "", printer_ticket: "", printer_ip: "" })
    const [formatVoucher, setformatVoucher] = useState("");
    const [printers, setPrinters] = useState([]);
    const [inputValueCoupon, setInputValueCoupon] = useState(0);
    const [modalTip, setModalTip] = useState(false);
    const [inputValueTip, setInputValueTip] = useState(0);
    const [orderPaymentMethodDetails, setOrderPaymentMethodDetails] = useState({});
    const [voucherTips, setVoucherTips] = useState(null);
    const [voucherModalTips, setVoucherModalTips] = useState(null);
    let machine = localStorage.getItem('machine');
    //Total taxes 
    const [totalTaxes, setTotalTaxes] = useState([
        { total_base: 0, tax: "0%", total_tax: 0 },
        { total_base: 0, tax: "7%", total_tax: 0 },
        { total_base: 0, tax: "10%", total_tax: 0 },
        { total_base: 0, tax: "15%", total_tax: 0 }
    ]);

    const orderTaxes = ["state_tax", "reduced_tax", "city_tax", "0%", "7%", "10%", "15%"]; // Orden deseado
    const printableOrderVoucher = resolveOrderVoucher(orderData);

    const groupedTaxes = Object.values(
        orderData.taxes.reduce((acc, item) => {
            if (!acc[item.tax]) {
                acc[item.tax] = { tax: item.tax, total: 0 };
            }
            acc[item.tax].total += item.total;
            return acc;
        }, {})
    )

    // Ordenar según el orden específico
    groupedTaxes.sort((a, b) => orderTaxes.indexOf(a.tax) - orderTaxes.indexOf(b.tax));

    //Branch office data
    const [branchOfficeData, setBranchofficeData] = useState({
        "ruc": "",
        "dv": "",
        "name": "",
        "ruc_type": "",
        "direction": "",
        "dgi_name": "",
    });


    if (machine !== '' && machine !== undefined && (machine !== null)) {
        machine = JSON.parse(localStorage.getItem('machine'));
    } else {
        machine = {
            id: 0
        }
    }
    //function action print order
    let arrayPrintersTemp = []
    const getPrinter = async () => {
        try {
            const response = await PrinterFetchAPI.getPrinter(localStorage.getItem('x-access-machine-token'), machine.id);

            let arrayPrinters = response.data.printers;
            let printer_Comanda = "";
            let printer_ticket = ""
            let printer_ip = ""
            for (let i = 0; i < arrayPrinters.length; i++) {
                getCategoriesByprinter(arrayPrinters[i])
                if (arrayPrinters[i].printer_type == 'Tickets') {
                    printer_ticket = arrayPrinters[i].printer_name
                    printer_ip = arrayPrinters[i].ip || ""
                } else if (arrayPrinters[i].printer_type == 'Comanda') {
                    printer_Comanda = arrayPrinters[i].printer_name
                }
            }
            setPrinters(arrayPrintersTemp)
            setInfoPrinter({ printer_comanda: printer_Comanda, printer_ticket: printer_ticket, printer_ip: printer_ip });

        } catch (err) {
            console.log(err);
        }
    }

    const getCategoriesByprinter = async (printer) => {

        try {
            const response = await CategriesPosFetchAPI.getCategoriesByPrinters(printer.printer_id, localStorage.getItem('x-access-machine-token'))
            printer.categories = response.data.categories

        } catch (err) {
            printer.categories = []
            console.log(err);
        }
        arrayPrintersTemp.push(printer)

    }


    const getinfoMachineById = async () => {

        console.log(orderData)
        try {
            const response = await MachinesFetchAPI.getmachineByid(orderData.machine_id, token)
            console.log(response)

            setInfoMachine(response.data.data);
        } catch (err) {
            console.log(err)
        }
    }

    //print order
    const printOrder = async (status) => {
        LoadingAlert()
        let type_ticket = ""
        let ip_print = "localhost"

        if (localStorage.getItem("ip_printer") != "" && localStorage.getItem("ip_printer") != undefined && localStorage.getItem("ip_printer") != null) {
            ip_print = localStorage.getItem("ip_printer")
        }

        if (orderData.devolution == true) {
            type_ticket = "Nota a credito"
        } else {
            type_ticket = "factura"
        }

        let arrayPrinters = []
        if (status == true) {
            printers.forEach((printer) => {
                if (printer.printer_type == "Tickets") {
                    arrayPrinters.push(printer)
                }
            });

        } else {
            printers.forEach((printer) => {
                arrayPrinters.push(printer)
            });
        }


        let JsonImprimir = [{
            "type_ticket": type_ticket,
            "Printers": arrayPrinters,
            "Nombre_maquina_impresora": infoPrinter.printer_ticket,
            "Nombre_cocina_impresora": infoPrinter.printer_comanda,
            "Nombre_zebra_impresora": "",
            "PRINTER_IP": infoPrinter.printer_ip,
            "Id_Orden_Imprimir": orderData._id,
            "token": localStorage.getItem('x-access-machine-token'),
            "transaction_code": orderData.code,
            "amount_item": orderData.groups.length,
            "imprimir_comanda": status == true ? "no" : "si",
        }]


        printOrderData(JsonImprimir);
        try {
            const response_machine = await MachinesFetchAPI.getmachineByid(machine.id, localStorage.getItem('x-access-machine-token'));

            if (ip_print == "localhost") {
                const response = await PrinterFetchAPI.printOrder(ip_print, JsonImprimir, response_machine.data.data.windows_ip)
            } else {
                const response = await PrinterFetchAPI.printByServerMiddle(ip_print, JsonImprimir)
            }
            ErrorAlert("La orden se imprimio con exito.", "Orden impresa", "success")
        } catch (err) {
            console.log(err);
            ErrorAlert("La orden no se imprimio con exito.", "Error en la impresion", "error")
        }
    }

    //We charge the items of the order 
    const orderItems = () => {
        let items = orderDetailGroups.map((product) => (
            <>

                {product.type === "separator" ? <>
                    <div className="d-flex text-muted pt-3 px-xs-2 border rounded border-primary border-2  mt-3 position-relative bg-white" key={product._id}>

                        <div className="pb-3 mb-0  lh-sm  w-100">
                            <div className="d-flex justify-content-between ">
                                {/* Name */}
                                <span className="text-dark fw-bold"><i class="uil uil-arrow-from-top">{product.name}</i></span>
                            </div>
                        </div>
                    </div></> : <>
                    <div className="d-flex text-muted pt-3 px-xs-2" key={product._id}>
                        <img className="bd-placeholder-img flex-shrink-0 me-2 rounded" loading='lazy' src={buildCloudinaryImageUrl({ url: product.img, width: 300, quality: "auto", type: "image" }) || defaultImage} width="42" height="42" />
                        <div className="pb-3 mb-0  lh-sm  w-100">
                            <div className="d-flex justify-content-between ">
                                {/* Name */}
                                <span className="text-dark fw-bold">{product.name} </span>
                                {/* Cantidad/ Quantity*/}
                                <div>
                                    <span className='px-3'>x {product.amount} </span>
                                    <label className="fw-bold" translate='no'>$ {product.price.toFixed(2)}</label>
                                </div>

                            </div>
                            {/** Segment items */}
                            <>
                                <div className="d-flex justify-content-between">
                                    {/* Name */}

                                    <span >{order_type === "permanent" ? "Descuento" : "Descuento unitario"}</span>
                                    {/* Cantidad/ Quantity*/}
                                    <div >
                                        {/** We check the type of modal and we return the input discount field depending of it */}
                                        <RenderIf isTrue={order_type === "permanent" || orderData.is_devolution_notification == true}>
                                            <label className={product.discount === undefined ? "" : "text-danger"}>{product.discount === undefined ? "No registrado" : "- $" + product.discount.toFixed(2)}</label>
                                        </RenderIf>

                                        <RenderIf isTrue={order_type === "temporal" && orderData.is_discount_notification == true}>
                                            <input
                                                type="number"
                                                className='form-control-sm text-danger text-end'
                                                min="0"
                                                step="0.01"
                                                name="product_discount"
                                                data-id={product._id}
                                                placeholder={product.unit_discount === undefined ? 0.00 : product.unit_discount.toFixed(2)}
                                            />
                                        </RenderIf>
                                    </div>
                                </div>
                                {product.segments.map((segments) => (
                                    <div className="d-flex justify-content-between" key={segments._id}>
                                        {/* item name */}
                                        <strong>{segments.name + ": "}</strong>
                                        <span className="">{segments.item.name}</span>
                                        <span className="">{parseFloat(segments.item.price).toFixed(2)}</span>
                                    </div>
                                ))}

                                <div>
                                    <div>
                                        <small className='text-primary p-1' >
                                            Entrega: {product.delivery_type}
                                        </small>
                                    </div>
                                    <div>
                                        <RenderIf isTrue={product.note != ""}>
                                            <small className='text-danger p-1' >
                                                Nota: {product.note}
                                            </small>
                                        </RenderIf>
                                    </div>
                                </div>




                            </>
                        </div>
                    </div></>}</>
        ));
        return <>{items}</>
    }

    //Template card Group of setGroup
    const cardGroup = (product) => {
        return (

            <div className="card-group">
                <div className="card">
                    <div className='d-flex justify-constent- between'>
                        <img loading='lazy' src={buildCloudinaryImageUrl({ url: product.img, width: 300, quality: "auto", type: "image" }) || defaultImage} className='m-2' alt="..." width="50" height="50" />
                        <div className="card-body">
                            <h5 className="card-title">{product.name}</h5>
                            <details close >
                                <summary className=''>
                                    <span className='badge bg-light text-dark summary-text-pos  fw-bold border rounded-4  text-wrap '>
                                        <i className="uil uil-info-circle  px-1 "></i>  Detalles
                                    </span>
                                </summary>
                                {product.segments.map(item => (
                                    <span className="badge bg-light text-dark  summary-text-pos m-2 border rounded-4 my-1 text-wrap ">
                                        {/* <span className='kiosk-subtitle-s' >   </span> */}
                                        <span className='text-muted m-0 p-0'>{item.name}:</span>
                                        <br />
                                        <strong>
                                            <span className='me-2'>{item.item.name} </span>
                                            {parseFloat(item.item.price).toFixed(2)}
                                        </strong>
                                    </span>
                                ))}
                            </details>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    const orderCombos = () => {
        let items = orderData.combos.map((product) => (
            <div className="d-flex text-muted pt-3 px-xs-2" key={product.combo_id}>
                <img className="bd-placeholder-img flex-shrink-0 me-2 rounded" loading='lazy' src={buildCloudinaryImageUrl({ url: product.img, width: 300, quality: "auto", type: "image" }) || defaultImage} width="42" height="42" />
                <div className="pb-3 mb-0  lh-sm  w-100">
                    <div className="d-flex justify-content-between ">
                        {/* Name */}
                        <span className="text-dark fw-bold">{product.name} </span>
                        {/* Cantidad/ Quantity*/}
                        <div>
                            <span className='px-3'>x {product.amount} </span>
                            <label className="fw-bold" translate='no'>$ {product.price.toFixed(2)}</label>
                        </div>

                    </div>
                    {/** Segment items */}
                    <>
                        <div className="d-flex justify-content-between">
                            {/* Name */}

                            <span >{order_type === "permanent" ? "Descuento" : "Descuento unitario"}</span>
                            {/* Cantidad/ Quantity*/}
                            <div >
                                {/** We check the type of modal and we return the input discount field depending of it */}
                                <RenderIf isTrue={order_type === "permanent" || orderData.is_devolution_notification == true}>
                                    <label className={product.discount === undefined ? "" : "text-danger"}>{product.discount === undefined ? "No registrado" : "- $" + product.discount.toFixed(2)}</label>
                                </RenderIf>

                                <RenderIf isTrue={order_type === "temporal" && orderData.is_discount_notification == true}>
                                    <input
                                        type="number"
                                        className='form-control-sm text-danger text-end'
                                        min="0"
                                        step="0.01"
                                        name="product_discount"
                                        data-id={product._id}
                                        placeholder={product.unit_discount === undefined ? 0.00 : product.unit_discount.toFixed(2)}
                                    />
                                </RenderIf>
                            </div>
                        </div>
                        {product.setGroups.map((setGroup) => (
                            <div className="d-flex justify-content-between" key={setGroup.set_id}>
                                <details close >
                                    <summary className=''>
                                        <span className='badge bg-light text-dark summary-text-pos  fw-bold border rounded-4  text-wrap m-1 '>
                                            <i className="uil uil-info-circle  px-1 "> {setGroup.name}</i>
                                        </span>
                                    </summary>
                                    {setGroup.groups.map((group) => (<>
                                        {cardGroup(group)}
                                    </>))}
                                </details>
                            </div>))}

                        <div>
                            <div>
                                <small className='text-primary p-1' >
                                    Entrega: {product.delivery_type}
                                </small>
                            </div>
                            <div>
                                <RenderIf isTrue={product.note != ""}>
                                    <small className='text-danger p-1' >
                                        Nota: {product.note}
                                    </small>
                                </RenderIf>
                            </div>
                        </div>




                    </>
                </div>
            </div>
        ));
        return <>{items}</>
    }

    //We charge the select discounts 
    const discountsOptions = () => {
        let discounts = businessDiscounts.map((discount) => (
            <option key={discount.discount_id} value={JSON.stringify(discount)}>{discount.discount_name}</option>
        ));
        return discounts
    }

    //Function to calculate the rouding of a discount
    const rounding = (amount_discount) => {

        let result = (amount_discount / 0.05).toFixed(2);
        //We verify if the result is int or decimal 
        if (result % 1 == 0) {
            console.log('no es decimal')
            amount_discount = parseFloat(amount_discount);
        } else {
            console.log('es decimal');
            amount_discount = parseFloat(amount_discount) + 0.01;
            rounding(amount_discount)
        }
        return amount_discount
    }


    //decimal reduction
    const decimalReduction = (value) => {
        let stringTax = mathRound(value).toString()
        let arraySteingTax = stringTax.split(".");
        let newDecimalTaxString = []
        let sampleTax = ''
        if (arraySteingTax[1] != undefined) {
            newDecimalTaxString = arraySteingTax[1].slice(0, 2);
            sampleTax = arraySteingTax[0] + "." + newDecimalTaxString
            console.log("Hice la reduccion");
        } else {
            console.log("Array: " + arraySteingTax);
            console.log("Decimal: " + newDecimalTaxString);
            console.log("Nuevo valor: " + sampleTax);
            sampleTax = stringTax;
        }

        let endValue = parseFloat(sampleTax).toFixed(2)
        return endValue
    }

    function mathRound(num) {
        //Respuesta de Rubén
        return Math.round(num * 100) / 100;
    }

    //Function to calculate the discounts 
    const calculateDiscounts = (jsondiscount) => {

        let json = JSON.parse(jsondiscount);
        setSelectDiscount(json.type);
        let discount = json.discountRate
        //We get the discount rate 
        let discount_rate = discount / 100;
        let totaldiscounts = 0;
        const discounts = document.getElementsByName('product_discount');

        //For every group we calculate the discount of it 
        for (let i = 0; i < orderDetailGroups.length; i++) {
            //We clear the input of the discount 
            discounts[i].value = ""
            //We get the group info 
            let group_info = orderDetailGroups[i];
            let unit_discount = decimalReduction(group_info.price * discount_rate);
            let total_product_discount = decimalReduction((group_info.price * discount_rate) * group_info.amount)
            orderDetailGroups[i].unit_discount = parseFloat(unit_discount)  //rounding(unit_discount);
            totaldiscounts = totaldiscounts + parseFloat(total_product_discount) //rounding(total_product_discount);
        }


        //We set the total discount of the order 
        orderData.discount = totaldiscounts;
        //We set the new order group detail info 
        setOrderDetailGroups(orderDetailGroups)
        //We set the total discount detail 
        setOrderDetailDiscountTotal(totaldiscounts);
        //We force the recharge of the component
        setEventHandler(1);
    }

    //Function to calculate the cupon 
    const calculateCupon = () => {


        let discount_rate = parseInt(inputValueCoupon);
        let totaldiscounts = 0;
        const discounts = document.getElementsByName('product_discount');
        setSelectDiscount("C");
        //For every group we calculate the discount of it 
        for (let i = 0; i < orderDetailGroups.length; i++) {
            //We clear the input of the discount 
            discounts[i].value = ""
            //We get the group info 
            let group_info = orderDetailGroups[i];

            let total_product_discount = (group_info.price * group_info.amount).toFixed(2);
            //Verify that the discount values ​​are greater than the total value of the quantity of products
            if (discount_rate >= total_product_discount) {

                //equalizes the value of the product to its unit discount
                let unit_discount = group_info.price
                total_product_discount = (group_info.price * group_info.amount).toFixed(2);
                orderDetailGroups[i].unit_discount = parseFloat(unit_discount)  //rounding(unit_discount);
                totaldiscounts = totaldiscounts + parseFloat(total_product_discount) //rounding(total_product_discount);
                //deducts the balance from the value of the discount applied
                discount_rate = (discount_rate - total_product_discount)


            } else {
                console.log(discount_rate);

                //Divide the discount by the quantity of the items in the group
                let unit_discount = (discount_rate / group_info.amount).toPrecision(2);

                if (unit_discount >= 0) {// validates that the unit discount is not negative
                    total_product_discount = (unit_discount * group_info.amount).toFixed(2);
                    totaldiscounts = totaldiscounts + parseFloat(total_product_discount) //rounding(total_product_discount);

                    if (totaldiscounts > parseInt(inputValueCoupon)) {// validate that the value of the discount is not greater than the value of the coupon
                        let diference_unit = ((totaldiscounts - parseInt(inputValueCoupon)) / group_info.amount) //calculate the difference between the discount and the coupon applied
                        unit_discount = (unit_discount - diference_unit) //calculates the adjusted unit discount
                        total_product_discount = (unit_discount * group_info.amount) //recalculates the value of the total product discount by the quantity
                        totaldiscounts = totaldiscounts - (totaldiscounts - parseInt(inputValueCoupon)) // readjusts the total discount applied
                        console.log(diference_unit);
                    }

                    console.log(unit_discount);
                    console.log(totaldiscounts);
                    orderDetailGroups[i].unit_discount = parseFloat(unit_discount)  //rounding(unit_discount);
                    discount_rate = (discount_rate - total_product_discount);
                }
            }
        }


        //We set the total discount of the order 
        orderData.discount = totaldiscounts;
        //We set the new order group detail info 
        setOrderDetailGroups(orderDetailGroups)
        //We set the total discount detail 
        setOrderDetailDiscountTotal(totaldiscounts);
        //We force the recharge of the component
        setEventHandler(1);

        setModalCoupon(false)
    }

    //We update the discount 
    const updateOrderDiscount = async () => {

        const discounts = document.getElementsByName('product_discount');
        let totaldiscounts = 0;


        //We update the status of the temp order 
        orderData.status_id = 9

        if (orderData.is_discount_notification == true) {
            let discount_empty = false

            //We get the discounts of the products 
            for (let i = 0; i < orderData.groups.length; i++) {
                let product_discount = discounts[i].value !== "" ? discounts[i].value : discounts[i].getAttribute('placeholder')
                console.log(selectDiscount);
                //We check if the discount is 0

                if (selectDiscount != "%") {

                    if (product_discount === 0 || product_discount === '0.00' || product_discount === '0') {
                        if (selectDiscount != "C") {
                            discount_empty = true
                        }
                    }
                } else {
                    orderData.groups[i].taxtValue = 0;
                    orderData.groups[i].tax = "0%";
                }

                //validates that the product discount is not greater than the price
                if (product_discount > orderData.groups[i].price) {
                    totaldiscounts = totaldiscounts + parseFloat(orderData.groups[i].price * orderData.groups[i].amount);
                    orderData.groups[i].unit_discount = parseFloat(orderData.groups[i].price);
                    orderData.groups[i].discount = parseFloat(orderData.groups[i].price);
                } else {
                    totaldiscounts = totaldiscounts + parseFloat(product_discount * orderData.groups[i].amount);
                    orderData.groups[i].unit_discount = parseFloat(product_discount);
                    orderData.groups[i].discount = parseFloat(product_discount * orderData.groups[i].amount);
                }
            }
            //We set the total discount of the order 
            orderData.discount = totaldiscounts;
            //We set the total discount detail 
            setOrderDetailDiscountTotal(totaldiscounts);

            if (discount_empty === true) {
                ErrorAlert('No puede haber descuentos en 0', 'Error', 'warning')
            } else {
                try {
                    //We update the temporal order
                    await OrdersFetchAPI.updateTempOrder(
                        {
                            "_id": orderData._id,
                            "status_id": orderData.status_id,
                            "groups": orderData.groups,
                            "discount": orderData.discount
                        },
                        token
                    );
                } catch (err) {
                    ErrorAlert(err.error)
                }
                //We close the modal 
                setModalShow(false)
                //We find the order on the temporal orders data 
                let index = temporalOrders.findIndex(order => order._id === orderData._id);
                //We delete the order updated 
                temporalOrders.splice(index, 1);
                //We set the temporal orders with the data updated 
                setTemporalOrdersData(temporalOrders);
                //We set the reload state to reload the component 
                setLoad(1)
            }
        } else {
            try {
                //We update the temporal order
                await OrdersFetchAPI.updateTempOrder(
                    {

                        "_id": orderData._id,
                        "status_id": orderData.status_id,
                        "groups": orderData.groups,
                        "discount": orderData.discount
                    },
                    token
                );
            } catch (err) {
                ErrorAlert(err.error)
            }
            //We close the modal 
            setModalShow(false)
            //We find the order on the temporal orders data 
            let index = temporalOrders.findIndex(order => order._id === orderData._id);
            //We delete the order updated 
            temporalOrders.splice(index, 1);
            //We set the temporal orders with the data updated 
            setTemporalOrdersData(temporalOrders);
            //We set the reload state to reload the component 
            setLoad(1)
        }
    }

    //We cancel the order discount 
    const cancelOrderDisocunt = async () => {
        //We update the status of the temp order (of cancel)
        orderData.status_id = 8
        try {
            //We update the temporal order
            await OrdersFetchAPI.updateTempOrder(
                {
                    "_id": orderData._id,
                    "status_id": orderData.status_id
                },
                token
            );
            //Alert message 
            SuccessAlert("Descuento cancelado")
        } catch (err) {
            ErrorAlert(err.error)
            console.log(err)
        }
        //We close the modal 
        setModalShow(false);
        //We find the order on the temporal orders data 
        let index = temporalOrders.findIndex(order => order._id === orderData._id);
        //We delete the order updated 
        temporalOrders.splice(index, 1);
        //We set the temporal orders with the data updated 
        setTemporalOrdersData(temporalOrders);
        //We set the reload state to reload the component 
        setLoad(1)
    }

    const handleViewCoucher = () => {
        setformatVoucher(formatVoucherString(printableOrderVoucher))
        setmodalShowVoucher(true)
    }

    //Function to get the payment methods of the machine
    const getPaymentMethods = async (machine_id) => {
        try {
            const response = await PaymentMethodFetchAPI.getPaymentMethod(machine_id, machineToken);
            return response.data.data;
        } catch (err) {
            setOrderPaymentMethodDetails([])
        }
    }

    //Hook to load the business discounts 
    useEffect(() => {
        (async () => {
            try {
                //We get the discounts 
                const discounts = await DiscountFetchAPI.getDiscountsByBusiness(business_data.id, token);
                setBusinessDiscounts(discounts.data.data);
            } catch (err) {
                setBusinessDiscounts([])
            }

            try {
                //We get the branchoffice info 
                const response_branch = await BranchOfficeFetchAPI.getBranchOfficeByCode(orderData.business.code, orderData.branchoffice.code);
                //We set the business data 
                setBranchofficeData(response_branch.data.branchoffice);

            } catch (err) {
                setBranchofficeData({
                    "ruc": "",
                    "dv": "",
                    "name": "",
                    "ruc_type": "",
                    "direction": "",
                    "dgi_name": "",
                })
            }
            try {
                //We get the payment methods of the machine
                const paymentMethods = await getPaymentMethods(orderData.machine_id);
                //We get the payment method of the order
                let paymentMethodOrder = paymentMethods.find(paymentMethod => paymentMethod.payment_id === orderData.paymenthod_id
                );
                //We set the payment method details
                setOrderPaymentMethodDetails(paymentMethodOrder);
            } catch (err) {
                setOrderPaymentMethodDetails({})
            }
        })();
    }, []);


    //We edit the tip of the order
    const editTip = async () => {
        //We get the user
        let user = JSON.parse(localStorage.getItem('user'));
        let tip_voucher = 0;
        try {
            //We check the payment integration to set the tip 
            if (orderData.paymenthod_integration_id === 6 && (orderData.tips === undefined || orderData.tips === 0)) {
                LoadingAlert()
                try {
                    //We edit the tip on the evertech api
                    let response = await PaymentOperations({
                        operationType: "adjust",
                        integrationType: 'Evertech',
                        params: orderPaymentMethodDetails.params,
                        sECRStationID: machine.code,
                        sCashierID: user.id,
                        sRefNumber: orderData.transaction_code,
                        sDataEntry: orderData.transaction_code,
                        tips: inputValueTip,
                        total: orderData.total,
                        subtotal: orderData.subtotal,
                        taxes: orderData.taxes,
                        tax: orderData.tax,
                        discount: orderData.discount,
                    });

                    //We check if the response is success
                    if (response && response.data && response.data.approval_code === "00") {
                        console.log("Adjust de evertec", response);
                        //We update the ord
                        tip_voucher = response.data.receipt_output.merchant + response.data.receipt_output.customer;
                        orderData.tips = parseFloat(inputValueTip);
                        setVoucherTips(tip_voucher)
                        //We update the tip of the order
                        await OrdersFetchAPI.updateOrder(
                            orderData._id,
                            {
                                tips: inputValueTip,
                                voucher_tips: tip_voucher
                            },
                            token);
                        //We set the voucher modal on true to show the voucher
                        setVoucherModalTips(false)
                        //We set event handler
                        setEventHandler(1)
                        //We close the modal
                        setModalTip(false);
                        //We show the success alert
                        SuccessAlert("Propina actualizada", "Propina", "success")
                    } else {
                        console.log("Error en el adjust de evertech", response);
                        //We show the error alert
                        ErrorAlert(response.data.response_message !== undefined ? response.data.response_message : "Error inesperado", 'Error en el adjust de evertech', 'error')
                    }
                } catch (err) {
                    console.log("error en acutalizar la propina")
                    ErrorAlert("Error al actualizar la propina", "Error", "error")
                }
            } else {
                ErrorAlert("No puede ajustar el tip en esta transaccion", "Advertencia", "warning")
            }

            //We update the tip of the order
        } catch (err) {
            console.log(err)
        }
    }

    //Hook to reload the component 
    useEffect(() => {
        getPrinter()
        setOrderDetailGroups(orderData.groups);
        setOrderDetailDiscountTotal(orderData.discount);
        setVoucherTips(orderData.voucher_tips);
        getPaymentMethods(orderData.machine_id).then((paymentMethods) => {
            let paymentMethodOrder = paymentMethods.find(paymentMethod => paymentMethod.payment_id === orderData.paymenthod_id);
            //We set the payment method details
            setOrderPaymentMethodDetails(paymentMethodOrder);
        });
        getinfoMachineById()
        setEventHandler(0);
    }, [eventHandler]);

    return (
        <Container className='mb-2'>
            {/* Your card */}
            <Row>
                <Col sm={12} md={12}  >
                    <div className="py-4 px-lg-4 ">
                        <div className="head-section-sp mt-2">
                            <div className="">
                                <div className="mt-1 mb-3">


                                    <div className="d-flex justify-content-between align-items-center mb-3 ">
                                        <div className='header-invoice'>
                                            <div>
                                                <h5 className='p-2'>
                                                    <span className="text-success"> {orderData.order_type === "devolution" ? "Orden de referencia: " : "Notificador:"} </span>
                                                    <span className="text-secondary"># {orderData.order_type === "devolution" && orderData.devolution_order_reference !== undefined ? orderData.devolution_order_reference.code : orderData.order_type === "devolution" && orderData.devolution_order_reference !== undefined ? "No tiene referencia" : orderData.locator ? orderData.locator : 0}</span>
                                                </h5>
                                            </div>
                                        </div>
                                        <h5>
                                            <span className="text-success">Orden: </span>
                                            <span className="text-secondary"> # {orderData.transaction_code ? orderData.transaction_code : 0}</span>
                                        </h5>



                                    </div>

                                    <div>
                                        <span className="text-nowrap text-secondary h6 d-block">
                                            <i className="fa-solid fa-store"></i>&nbsp;
                                            Sucursal: {orderData.branchoffice.name}
                                        </span>
                                        <span className="text-nowrap text-primary h6 d-block">
                                            <i className="fa-solid fa-cash-register"></i>&nbsp;
                                            {infoMachine.machine_name} / {!orderData.user ? 'No es cajera' : orderData.user.name}
                                        </span>
                                        <span className="text-nowrap text-secondary h6 d-block">
                                            <i className="fa-solid fa-mobile-screen"></i>&nbsp;
                                            Máquina: {infoMachine.code}
                                        </span>
                                        <span className="text-nowrap text-secondary h6 d-block">
                                            {orderData?.aditional_info}
                                        </span>
                                    </div>

                                </div>
                            </div>
                            <RenderIf isTrue={order_type == "temporal" && orderData.is_discount_notification == true}>
                                <div className="">
                                    <div className="mt-1 mb-3">
                                        <div className="m-3 d-flex justify-content-center alight-item-center ">
                                            <Button className='' onClick={() => (setModalCoupon(true))}><i class="uil uil-ticket"></i> Aplicar un cupon</Button>
                                        </div>
                                        <div className="mb-3 ">
                                            <label htmlFor="">Seleccione el descuento</label>
                                            <select className='form-select mt-2' onChange={e => calculateDiscounts(e.target.value === "Seleccione..." ? 0 : e.target.value)} name="" id="">
                                                <option value={null}>Seleccione...</option>
                                                {discountsOptions()}
                                            </select>
                                        </div>

                                    </div>
                                </div>
                            </RenderIf>
                            <div className=' d-flex justify-content-between text-secondary opacity-75'>
                                <div> Productos </div>
                                <div> Precio </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 col-lg-12 order-md-last">
                                    {/* Item cards */}
                                    {orderItems()}
                                    {orderCombos()}
                                    {/**Total details */}
                                    <div className="d-flex text-muted pt-3">
                                        <div className="pb-3 mb-0 small lh-sm border-top w-100">

                                            <div className="d-flex justify-content-end mt-3">
                                                <span className="text-gray-dark fw-light h6"> Descuento: </span>
                                                <span className='text-danger fw-light h6'>
                                                    <span className='px-2 ' translate='no'>- $</span>
                                                    {orderDetailDiscountTotal.toFixed(2)}
                                                </span>
                                            </div>

                                            {/** We render the totals if the order is type permanent */}
                                            <RenderIf isTrue={order_type === "permanent"}>
                                                <div className="d-flex justify-content-end mt-3">
                                                    <span className="text-gray-dark fw-light h6"> Subtotal: </span>
                                                    <span className='text-black fw-light h6'>
                                                        <span className='px-2 ' translate='no'>$</span>
                                                        {orderData.subtotal.toFixed(2)}
                                                    </span>
                                                </div>

                                                {groupedTaxes.map((tax) => (
                                                    <>
                                                        <div className="d-flex justify-content-end mt-3">
                                                            <span className="text-gray-dark fw-light h6"> Impuesto {tax.tax}: </span>
                                                            <span className='text-black fw-light h6'>
                                                                <span className='px-2 ' translate='no'>$</span>
                                                                {tax.total.toFixed(2)}
                                                            </span>
                                                        </div>
                                                    </>
                                                ))}
                                                <div className="d-flex justify-content-end mt-3">
                                                    <strong className="text-black h5"> Total: </strong>
                                                    <span className='text-black fw-bold h5'>
                                                        <span className='px-2 ' translate='no'>$ </span>
                                                        {orderData.total.toFixed(2)}
                                                    </span>
                                                </div>

                                                {orderData.tips ? <>
                                                    {orderData.tips > 0 ? <>
                                                        <div className="d-flex justify-content-end mt-3">
                                                            <span className="text-gray-dark fw-light h6"> Propina: </span>
                                                            <span className='text-black fw-light h6'>
                                                                <span className='px-2 ' translate='no'>$</span>
                                                                {orderData.tips.toFixed(2)}
                                                            </span>
                                                        </div></> : <></>}</> : <></>}
                                            </RenderIf>

                                            {/** We render the buttons if the order is type temporal */}
                                            <RenderIf isTrue={order_type === "temporal"}>
                                                <div className='d-flex mt-4 justify-content-between'>
                                                    <Button variant="danger" onClick={cancelOrderDisocunt} className='btn col-5' >
                                                        Cancelar
                                                    </Button>
                                                    <Button variant="success" onClick={updateOrderDiscount} className='btn col-5' >
                                                        {orderData.is_discount_notification === true ? "Aprobar descuento" : "Aprobar devolución"}
                                                    </Button>
                                                </div>
                                            </RenderIf>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>

            </Row>

            {/** Modal voucher */}
            <Modal

                show={modalShowVoucher}
                onHide={() => setmodalShowVoucher(false)}
                centered>
                <Modal.Header>
                    Voucher de transaccion: #{orderData.transaction_code}
                </Modal.Header>
                <Modal.Body>
                    <div className='d-flex alight-item-center justify-content-center'>
                        <div>
                            <pre>{formatVoucher}</pre>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => (setmodalShowVoucher(false))}>Cerrar</Button>
                </Modal.Footer>
            </Modal>

            {/**Print button  */}
            <RenderIf isTrue={order_type === "permanent"}>
                <RenderIf isTrue={pos == true}>
                    <Button className='m-2' onClick={() => (printOrder(true))}><i className="uil uil-print m-1"></i> Imprimir solo factura</Button>
                    <Button className='m-2' onClick={() => (printOrder(false))}><i className="uil uil-print m-1"></i> Imprimir factura con comanda</Button>
                </RenderIf>
            </RenderIf>

            {/** Editar propina */}
            <RenderIf isTrue={order_type === "permanent" && (orderData.tips === undefined || orderData.tips == 0) && orderData.paymenthod_integration_id === 6}>
                <Button className='m-2' onClick={() => setModalTip(true)}><i className="uil uil-money-bill m-1"></i> Editar propina</Button>
            </RenderIf>

            <RenderIf isTrue={order_type === "permanent" && orderData.voucher_tips !== undefined && orderData.tips && orderData.tips > 0 && orderData.voucher_tips != 0}>
                <Button className='m-2' onClick={() => (setVoucherModalTips(true))}><i className="uil uil-receipt-alt"></i> Voucher de la propina</Button>
            </RenderIf>

            {/**Voucher button */}
            <RenderIf isTrue={Boolean(printableOrderVoucher) && order_type === "permanent"}>
                <Button className='m-2' onClick={() => (handleViewCoucher())}><i className="uil uil-receipt-alt"></i> Voucher de transaccion</Button>
            </RenderIf>

            {/** PDF button */}
            <RenderIf isTrue={order_type === "permanent"}>
                {/*<PDFDownloadLink className='pdf-viewer-sp' document={<DocPdf
                    doc_type={orderData.invoice_type === "devolution" ? "credit_note" : "invoice"} invoiceQR={orderData.dgi_qr} invoiceDate={orderData.createdAt} cufe={orderData.cufe} auth_protocol={orderData.auth_protocol ? orderData.auth_protocol : "00000000"}
                    receptor={{
                        name: orderData.client_name,
                        ruc: orderData.client_ruc,
                        direction: orderData.client_address,
                        dv: orderData.client_dv,
                        phone: orderData.client_phone,
                        aditional_info: orderData.aditional_info
                    }}
                    emitter={branchOfficeData}
                    products={orderData.groups} invoiceSubtotal={orderData.subtotal} totalTaxes={totalTaxes}
                    totalCashReceived={orderData.total} invoiceTotal={orderData.total} invoiceTotalItbms={orderData.tax} paymentMethod={orderData.paymenthod}
                />} >
                    <button className='btn btn-secondary-sp border border-sp' > {orderData.invoice_type === "devolution" ? "Descargar nota de credito" : "Descargar factura electronica"} </button>
                </PDFDownloadLink>*/}

                <PDFDownloadLink className='pdf-viewer-sp' document={<InvoicePDF
                    data={{
                        emisor: orderData.branchoffice.fiscal_name,
                        emisorRuc: orderData.branchoffice.ruc,
                        emisorDv: orderData.branchoffice.dv,
                        emisorDireccion: branchOfficeData.direction,
                        clienteNombre: orderData.client_name,
                        clienteRuc: orderData.client_ruc,
                        clienteDv: orderData.client_dv,
                        clienteDireccion: orderData.client_address,
                        clienteTelefono: orderData.client_phone,
                        fechaEmision: orderData.createdAt ? new Date(orderData.createdAt).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' }) : '',
                        puntoFacturacion: infoMachine.code,
                        consultaClaveUrl: orderData.dgi_qr,
                        cufe: orderData.cufe,
                        items: orderData.groups,
                        itbmsBreakdown: orderData.taxes,
                        metodoPago: orderData.paymenthod,
                        formaPagoMonto: "",
                        totalPagado: orderData.total,
                        tips: orderData.tips,
                        subtotal: orderData.subtotal,
                        discount: orderData.discount,
                        tax: orderData.tax,
                        total: orderData.total,
                        typeDocument: orderData.order_type === "devolution" ? "credit_note" : "invoice",
                        logo: logo,
                        aditional_info: orderData.aditional_info ? orderData.aditional_info : "",
                        note: orderData.note || '',
                        transaction_code: orderData.transaction_code || ''


                    }} />} >
                    <button className='btn btn-secondary-sp border border-sp' > {orderData.invoice_type === "devolution" ? "Descargar nota de credito" : "Descargar factura electronica"} </button>
                </PDFDownloadLink>
            </RenderIf>


            {/** Modal tip */}
            <Modal
                show={modalTip}
                size="md"
                onHide={() => setModalTip(false)}
                aria-labelledby="example-custom-modal-styling-title"
                centered
            >
                <div className='mt-2 text-center p-1'>
                    <h4 className='fw-bold'>  Propina </h4>
                </div>
                <Modal.Body>
                    <div className="input-group input-group-lg">
                        <input type="text" className="form-control" placeholder='Ingrese la propina $0.00' onChange={(e) => (setInputValueTip(e.target.value))} />
                    </div>

                    <div className='d-flex justify-content-between mt-3'>
                        <button className='btn btn-danger btn-lg' onClick={() => setModalTip(false)}> Cancelar </button>
                        <button className='btn btn-success btn-lg' onClick={() => editTip()} > Aplicar  </button>
                    </div>
                </Modal.Body>
            </Modal>


            {/** Modal of voucher tips */}
            <Modal
                show={voucherModalTips}
                onHide={() => setVoucherModalTips(false)}
                centered>
                <Modal.Header>
                    Voucher de transaccion: #{orderData.transaction_code}
                </Modal.Header>
                <Modal.Body>
                    <div className='d-flex alight-item-center justify-content-center'>
                        <div>
                            <pre>{voucherTips}</pre>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => (setVoucherModalTips(false))}>Cerrar</Button>
                </Modal.Footer>
            </Modal>


            {/** Modal cupon */}
            <Modal
                show={modalCoupon}
                size="md"
                onHide={() => setModalCoupon(false)}
                aria-labelledby="example-custom-modal-styling-title"
                centered
            >
                <div className='mt-2 text-center p-1'>
                    <h4 className='fw-bold'>  Cupon </h4>
                </div>
                <Modal.Body>
                    <div className="input-group input-group-lg">
                        <input type="number" className="form-control" placeholder='Ingrese el monto del cupon $0.00' onChange={(e) => (setInputValueCoupon(e.target.value))} />
                    </div>

                    <div className='d-flex justify-content-between mt-3'>
                        <button className='btn btn-danger btn-lg' onClick={() => setModalCoupon(false)}> Cancelar </button>
                        <button className='btn btn-success btn-lg' onClick={() => calculateCupon()} > Aplicar  </button>
                    </div>
                </Modal.Body>
            </Modal>


        </Container>


    );
}

export default OrderDetails;
